export default "__VITE_ASSET__Ddulymp7__"